import type { StorefrontSiteConfig } from '@/lib/api'
import {
  assertStorefrontConfigIdentity,
  readStorefrontRuntime,
  resolveExpectedStorefrontConfigIdentity,
} from '@/lib/storefront-config-identity'

declare global {
  interface Window {
    __STOREFRONT_CONTRACT_VERSION__?: unknown
    __STOREFRONT_SITE_CONFIG__?: unknown
  }
}

const readSnapshotSource = () => {
  if (typeof window !== 'undefined') return window.__STOREFRONT_SITE_CONFIG__
  return (globalThis as typeof globalThis & { __STOREFRONT_SITE_CONFIG__?: unknown })
    .__STOREFRONT_SITE_CONFIG__
}

const readContractVersionSource = () => {
  if (typeof window !== 'undefined') return window.__STOREFRONT_CONTRACT_VERSION__
  return (globalThis as typeof globalThis & { __STOREFRONT_CONTRACT_VERSION__?: unknown })
    .__STOREFRONT_CONTRACT_VERSION__
}

export const isDeploySnapshotStorefront = () => (
  Number(readContractVersionSource()) === 1
  || readStorefrontRuntime() !== null
)

export const shouldShowStorefrontSiteConfigLoading = (
  isLoading: boolean,
  isDeploySnapshot: boolean
) => isLoading && !isDeploySnapshot

export const readStorefrontSiteConfigSnapshot = (): StorefrontSiteConfig | null => {
  if (!isDeploySnapshotStorefront()) return null

  const source = readSnapshotSource()
  if (!source || typeof source !== 'object' || Array.isArray(source)) {
    throw new Error('storefront_site_config_snapshot_missing')
  }

  assertStorefrontConfigIdentity(source, resolveExpectedStorefrontConfigIdentity())
  return source as StorefrontSiteConfig
}
